import { getAccOrigin } from "@adsk/acs-sc-web-platform-api";

const getAssetUrl = (projectId: string, assetId: string): string =>
  `${getAccOrigin()}/build/assets/projects/${projectId}/assets?assetId=${assetId}`;

export default getAssetUrl;
